export default {"src":"/_next/static/media/data_protection.9359f97f.svg","height":192,"width":217,"blurWidth":0,"blurHeight":0};